export const alarmConfig = {
  highVolt: {
    title: "alarms.highVolt",
    state: "Röle-1 Yüksek Volt Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueV", description: "Röle-1 Yüksek Volt Hata Limiti", factor: 0.1, min: 110, max: 260 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Yüksek Volt Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Yüksek Volt Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Yüksek Volt Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  lowVolt: {
    title: "alarms.lowVolt",
    state: "Röle-1 Düşük Volt Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueV", description: "Röle-1 Düşük Volt Hata Limiti", factor: 0.1, min: 80, max: 210 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Düşük Volt Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Düşük Volt Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Düşük Volt Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  highCurrent: {
    title: "alarms.highCurrent",
    state: "Röle-1 Yüksek Akım Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueA", description: "Röle-1 Yüksek Akım Hata Limiti", factor: 0.001, min: 0.1, max: 5.5 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Yüksek Akım Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Yüksek Akım Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Yüksek Akım Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  lowCurrent: {
    title: "alarms.lowCurrent",
    state: "Röle-1 Düşük Akım Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueA", description: "Röle-1 Düşük Akım Hata Limiti", factor: 0.001, min: 0.1, max: 5.0 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Düşük Akım Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Düşük Akım Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Düşük Akım Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  highNeutralCurrent: {
    title: "alarms.highNeutralCurrent",
    state: "Röle-1 Yüksek Nötr Akım Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueA", description: "Röle-1 Yüksek Nötr Akım Hata Limiti", factor: 0.001, min: 0.1, max: 5.5 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Yüksek Nötr Akım Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Yüksek Nötr Akım Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Yüksek Nötr Akım Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  unbalanceVoltage: {
    title: "alarms.unbalanceVoltage",
    state: "Röle-1 Gerilim Dengesizlik Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valuePercent", description: "Röle-1 Gerilim Dengesizlik Hata Limiti", factor: 0.1, min: 1, max: 99.9 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Gerilim Dengesizlik Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Gerilim Dengesizlik Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Gerilim Dengesizlik Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  unbalanceCurrent: {
    title: "alarms.unbalanceCurrent",
    state: "Röle-1 Akım Dengesizlik Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valuePercent", description: "Röle-1 Akım Dengesizlik Hata Limiti", factor: 0.1, min: 1, max: 99.9 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Akım Dengesizlik Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Akım Dengesizlik Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Akım Dengesizlik Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  highFrequency: {
    title: "alarms.highFrequency",
    state: "Röle-1 Yüksek Frekans Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueHz", description: "Röle-1 Yüksek Frekans Hata Limiti", factor: 0.01, min: 50, max: 80 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Yüksek Frekans Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Yüksek Frekans Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Yüksek Frekans Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  lowFrequency: {
    title: "alarms.lowFrequency",
    state: "Röle-1 Düşük Frekans Hata Kontrol Aktivasyonu",
    fields: [
      { key: "limit", label: "alarms.valueHz", description: "Röle-1 Düşük Frekans Hata Limiti", factor: 0.01, min: 40, max: 60 },
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Düşük Frekans Hataya Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Düşük Frekans Hatadan Çıkması için Gereken Süre", factor: 0.1 },
      { key: "hysteresis", label: "alarms.hysteresis", description: "Röle-1 Düşük Frekans Hatadan Çıkış Histeriz Değeri", factor: 0.1, min: 1, max: 20 },
    ],
  },
  phaseSequence: {
    title: "alarms.phaseSequence",
    state: "Röle-1 Faz Sırası Hata Kontrol Aktivasyonu",
    fields: [
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Faz Sırası Hatasına Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Faz Sırası Hatasından Çıkması için Gereken Süre", factor: 0.1 },
    ],
  },
  phaseLoss: {
    title: "alarms.phaseLoss",
    state: "Röle-1 Faz Yokluğu Hata Kontrol Aktivasyonu",
    fields: [
      { key: "delay", label: "alarms.delayTime", description: "Röle-1 Faz Yokluğu Hatasına Girmesi için Gereken Süre", factor: 0.1 },
      { key: "return", label: "alarms.returnTime", description: "Röle-1 Faz Yokluğu Hatasından Çıkması için Gereken Süre", factor: 0.1 },
    ],
  },
  latch: {
    title: "alarms.latch",
    state: "Röle-1 Tutma Koruma Aktivasyon Durumu",
    fields: [],
  },
  inverse: {
    title: "alarms.inverse",
    state: "Röle-1 Tersleme Aktivasyon Durumu",
    fields: [],
  },
};
